import { render, staticRenderFns } from "./HonorList.vue?vue&type=template&id=0049d7d8&scoped=true"
import script from "./HonorList.vue?vue&type=script&lang=js"
export * from "./HonorList.vue?vue&type=script&lang=js"
import style0 from "./HonorList.vue?vue&type=style&index=0&id=0049d7d8&prod&scoped=true&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049d7d8",
  null
  
)

export default component.exports